import ApiBaseURLProps from "../other/apiBaseURL";
import axios from "axios";

function sanitizeFileName(fileName) {
  return fileName.replace(/&/g, ''); // Replace all '&' characters with an empty string
}

class FileUploadService {
  uploadFile(file, fileName) {
    var formData = new FormData();
    formData.append("fileUpload", file, fileName ? sanitizeFileName(fileName) : sanitizeFileName(file.name));
    return axios.post(ApiBaseURLProps.apiBaseURL + "/file/upload", formData, { headers: { "Content-Type": 'multipart/form-data' } });
  }
}

export default new FileUploadService();
